"use strict";module.exports = function* selfIterator() {
  yield this;
};